import { Link, Route, Routes } from "react-router";
import Dashboard from "../app/dashboard";
import { ProtectedRoute } from "./protectedroute";
import Login from "../app/login";
import { ProviderAuth } from "../api/auth";
import AppTheme from "../theme/theme";
import { CssBaseline } from "@mui/material";
import GoodsIn from "../app/goods-in";
import GoodsInDetails from "../app/goods-in/details";
import StockLocations from "../app/stock-locations";
import StockLocationDetails from "../app/stock-locations/details";
import Products from "../app/products";
import ProductDetails from "../app/products/details";
import Stock from "../app/stock";
import StockDetails from "../app/stock/details";
import StockRelocations from "../app/relocations";
import StockRelocationDetails from "../app/relocations/details";
import Audit from "../app/audit";
import AuditDetails from "../app/audit/details";
import ProductExpiryWarnings from "../app/stock/warnings/expiry";

export const AppRouter = () => {
    return (
        <>
            <AppTheme>
                <CssBaseline enableColorScheme />
                <ProviderAuth>
                    <Routes>
                        <Route path="login" element={<Login />} />
                        <Route element={<ProtectedRoute redirectPath="/login" />}>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/goods-in" element={<GoodsIn />} />
                            <Route path="/goods-in/:id" element={<GoodsInDetails />} />
                            <Route path="/locations" element={<StockLocations />} />
                            <Route path="/locations/:id" element={<StockLocationDetails />} />
                            <Route path="/products" element={<Products />} />
                            <Route path="/products/:id" element={<ProductDetails />} />
                            <Route path="/stock" element={<Stock />} />
                            <Route path="/stock/:id" element={<StockDetails />} />
                            <Route path="/stock/warnings/expiry" element={<ProductExpiryWarnings />} />
                            <Route path="/relocations" element={<StockRelocations />} />
                            <Route path="/relocations/:id" element={<StockRelocationDetails />} />
                            <Route path="/audit" element={<Audit />} />
                            <Route path="/audit/:id" element={<AuditDetails />} />
                        </Route>
                        <Route path="*" element={<p>There's nothing here: 404!</p>} />
                    </Routes>
                </ProviderAuth>
            </AppTheme>
        </>
    );
};